import { ReactNode } from 'react';
import { ApolloProvider } from '@bloomcode/apollo';
import { AuthProvider } from '@bloomcode/auth';
import {
  UserPreferencesProvider,
  AuthorizationProvider,
  ThemeSyncProvider,
} from '@bloomcode/shared-modules';
import { TooltipProvider } from '@bloomcode/ui';
import { ScopeProvider } from '@/core/context';
import { I18nProvider } from '@bloomcode/i18n';
import { getAppUrl } from '@bloomcode/config';

const GRAPHQL_ENDPOINT = '/api/graphql';
const AUTH_PORTAL_URL = getAppUrl('portal-auth');

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ApolloProvider
      config={{ graphqlEndpoint: GRAPHQL_ENDPOINT, enableLogging: import.meta.env.DEV }}
    >
      <AuthProvider
        apiBaseUrl={GRAPHQL_ENDPOINT.replace('/graphql', '')}
        authPortalUrl={AUTH_PORTAL_URL}
        redirectIfNoSession={true}
      >
        <UserPreferencesProvider>
          <AuthorizationProvider
            onSessionExpired={() => {
              window.location.href = AUTH_PORTAL_URL;
            }}
            onUnauthorized={() => {}}
          >
            <ScopeProvider>
              <I18nProvider>
                <ThemeSyncProvider>
                  <TooltipProvider delayDuration={300}>{children}</TooltipProvider>
                </ThemeSyncProvider>
              </I18nProvider>
            </ScopeProvider>
          </AuthorizationProvider>
        </UserPreferencesProvider>
      </AuthProvider>
    </ApolloProvider>
  );
}
